<template>
    <div>
        <div v-if="$route.meta.top=='dome1'">
            <div class="top">
                <div style="width: 1200px;margin: 0 auto;display: flex;align-items: center;justify-content: space-between;">
                    <div style="display: flex;align-items: center;">
                        <span>{{ $t('view.您好，欢迎来到信翼通招标网！') }}</span>
                        <span v-if="!$store.getters.name">
                            <span @click="$refs.Login.init()" style="cursor: pointer;border-right: 1px solid #979797;padding-right: 15px;" class="Mainclick"> {{ $t('view.登录') }} </span>
                            <span  @click="$router.push('/Register')" style="margin-left: 15px;cursor: pointer;"> {{ $t('view.注册') }} </span>
                        </span>
                        <span v-else style="display: flex;align-items: center;">
                            <div @click="Jump('/MyBid')" class="mainColor single-line" style="cursor: pointer;width: 40px;" :title="$store.getters.name">{{$store.getters.name}}</div>
                            <span style="margin-left: 10px;cursor: pointer;" @click="exit">{{ $t('view.退出') }}</span>
                            <div @click="warningTime" class="mainColor single-line" style="margin:0 10px;width: 70px;" :title="operationMsg?operationMsg:operation=='prompt'? $t('view.认证信息已上传，目前正在审核中，请耐心等待'):operation=='skip'? $t('view.已认证'):$t('view.去认证')">{{ operationMsg?operationMsg:operation=='prompt'? $t('view.认证信息已上传，目前正在审核中，请耐心等待'):operation=='skip'? $t('view.已认证'):$t('view.去认证') }}</div>
                        </span> 
                    </div>
                    <div>
                        <span style="margin-right: 10px;">
                            <span>商务联系: </span>
                            <span style="color: #B80008;">contact@sghengfu.com</span>
                        </span>
                        <span style="margin-right: 10px;">
                            <span>举报投诉: </span>
                            <span style="color: #B80008;">accept@sghengfu.com</span>
                        </span>
                        <span >|</span>
                        <span class="btnClick" @click="Jump('/')" >{{$t('view.首页')}}</span>
                        <span v-if="$store.getters.name" >|</span>
                        <span   v-if="$store.getters.name" style="position: relative;" class="btnClick" @click="Jump('/MyBid')">
                            {{ $t('view.工作台') }}
                            <span v-if="HandlingMattersNum" class="HandlingMattersNum">{{ HandlingMattersNum }}</span>
                        </span>
                       
                        <span style="margin-right:10px ">|</span>
                        <el-dropdown trigger="click" style="font-size: 12px; color: #747474;">
                            <span class="el-dropdown-link " style="cursor: pointer;line-height: 53px;">
                            {{languages }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" style="font-size: 12px;">
                            <el-dropdown-item @click.native="handleChangeLanguage('zh')">简体中文</el-dropdown-item>
                            <el-dropdown-item @click.native="handleChangeLanguage('en')">English</el-dropdown-item>
                            <el-dropdown-item @click.native="handleChangeLanguage('lo')">bahasa Indonesia</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span style="margin:0 10px ">|</span>
                        <el-dropdown trigger="click" style="font-size: 12px; color: #747474;">
                            <span class="el-dropdown-link" style="cursor: pointer;color: #B70008;line-height: 53px;">
                            {{$t('view.APP下载') }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <el-dropdown-item>
                                        <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px;">{{ $t('view.信翼通招标系统App') }}</div>
                                        <!-- <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px;">{{ $t('view.(仅限安卓版本)') }}</div> -->
                                        <div v-if="ENV!='production'" style="margin: 0 auto;text-align: center"> <img  style="width:108px;" src="../assets/code.png"></div>
                                        <div v-else style="margin: 0 auto ;text-align: center"> <img  style="width:108px;" src="../assets/productionCode.png"></div>
                                        <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px">{{ $t('view.可使用微信扫一扫扫码下载') }}</div>
                                    </el-dropdown-item>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                </div>
            </div>
            <div style="width: 100%;" class="dome1Bg">
                <div style="width: 1200px;padding: 10px 0; margin: 0 auto;display: flex;justify-content: space-between;align-items: center;">
                    <div style="display: flex;align-items: center;margin: 10px 0;" @click="Jump('/')">
                        <img style="width: 52px;cursor: pointer;" src="../assets/logo1.png">
                        <div class="title" style="color: #fff;cursor: pointer;" >{{ $t('view.信翼通招标网') }}</div>
                    </div>
                    <div style="display: flex;" class="seachInput">
                        <el-input  style="width: 616px;" v-model="input"  :placeholder="$t('view.请输入项目名称')" @keyup.enter.native="seach" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="seach"></el-button>
                        </el-input>
                    </div>
                </div>
            </div>
        </div>
        <!-- 样式1  首页-->
        <div v-else style="background: #fff;">
            <div class="TopBox">
                <div class="top">
                    <div style="width: 1200px;margin: 0 auto;display: flex;justify-content: space-between;align-items: center;">
                        <div id="zcw_Top_Welcome" style="display: flex;align-items: center;">
                            <span>{{ $t('view.您好，欢迎来到信翼通招标网！') }}</span>
                            <span v-if="!$store.getters.name">
                                <span @click="$refs.Login.init()" style="cursor: pointer;border-right: 1px solid #979797;padding-right: 15px;" class="Mainclick"> {{$t('view.登录')}} </span>
                                <span  @click="$router.push('/Register')" style="margin-left: 15px;cursor: pointer;"> {{ $t('view.注册') }} </span>
                            </span>
                            <span v-else style="display: flex;align-items: center;">
                                <div @click="Jump('/MyBid')" class="mainColor single-line" style="cursor: pointer;width: 40px;" :title="$store.getters.name">{{$store.getters.name}}</div>
                                <span style="margin-left: 10px;cursor: pointer;" @click="exit">{{ $t('view.退出') }}</span>
                                <div @click="warningTime" class="mainColor single-line" style="margin:0 10px;width: 70px;" :title="operationMsg?operationMsg:operation=='prompt'? $t('view.认证信息已上传，目前正在审核中，请耐心等待'):operation=='skip'? $t('view.已认证'):$t('view.去认证')">{{ operationMsg?operationMsg:operation=='prompt'? $t('view.认证信息已上传，目前正在审核中，请耐心等待'):operation=='skip'? $t('view.已认证'):$t('view.去认证') }}</div>
                            </span>
                        </div>
                        <div>
                            <span id="workbench">
                                <span style="margin-right: 10px;">
                                    <span>商务联系: </span>
                                    <span style="color: #B80008;">contact@sghengfu.com</span>
                                </span>
                                <span style="margin-right: 10px;">
                                    <span>举报投诉: </span>
                                    <span style="color: #B80008;">accept@sghengfu.com</span>
                                </span>
                                <span >|</span>
                                <span class="btnClick" @click="Jump('/')" >{{$t('view.首页')}}</span>
                                <span v-if="$store.getters.name">|</span>
                                <span  v-if="$store.getters.name" style="position: relative;"  class="btnClick" @click="Jump('/MyBid')">
                                    {{ $t('view.工作台') }}
                                    <span v-if="HandlingMattersNum" class="HandlingMattersNum">{{ HandlingMattersNum }}</span>
                                </span>
                                <span style="margin-right:10px ">|</span>
                                <el-dropdown trigger="click" style="font-size: 12px; color: #747474;">
                                    <span class="el-dropdown-link" style="cursor: pointer;line-height: 53px;">
                                    {{languages }}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" style="font-size: 12px;">
                                    <el-dropdown-item @click.native="handleChangeLanguage('zh')">简体中文</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeLanguage('en')">English</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeLanguage('lo')">bahasa Indonesia</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                            <span style="margin:0 10px ">|</span>
                            <el-dropdown id="download" trigger="click" style="font-size: 12px; color: #747474;">
                                <span class="el-dropdown-link" style="cursor: pointer;color: #B70008;line-height: 53px;">
                                {{$t('view.APP下载') }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px;">{{ $t('view.信翼通招标系统App') }}</div>
                                        <!-- <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px;">{{ $t('view.(仅限安卓版本)') }}</div> -->
                                        <div v-if="ENV!='production'" style="margin: 0 auto;text-align: center"> <img  style="width:108px;" src="../assets/code.png"></div>
                                        <div v-else style="margin: 0 auto ;text-align: center"> <img  style="width:108px;" src="../assets/productionCode.png"></div>
                                        <div style="text-align: center;font-size: 14px;color: #333333;line-height: 20px">{{ $t('view.可使用微信扫一扫扫码下载') }}</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>

                            </el-dropdown>
                        </div>
                    </div>
                </div>
                <div class="titleList">
                    <!-- 搜索栏 -->
                    <div style="width: 1200px;margin: 0 auto; display: flex; align-items: center;height: 100px;" id="search">
                        <img @click="Jump('/')" style="width: 52px;height:52px;cursor: pointer;" src="../assets/logo.png">
                        <div class="title" style="cursor: pointer;" @click="Jump('/')">{{ $t('view.信翼通招标网') }}</div>
                        <el-input style="width: 516px;" prefix-icon="el-icon-search" :placeholder="$t('view.请输入项目名称')" v-model="input" @keyup.enter.native="seach">
                        </el-input>
                        <div class="search" @click="seach">{{$t('view.搜索')}}</div>
                        <!-- title -->

                        <img style="margin-left: 60px;" :src="require('@/assets/top/title'+chooseLanguage+'.png')">
                    </div>
                </div>
              
            </div>
            
            <div class="classification">
                <div :class="['titleItem',(url=='/'||url=='/TenderProject'||searchType)?'chose':'']"  @click="Jump('/')">
                    <div :class="[url=='/MaterialProject'?'':'lineBorder']" style="height: 20px;line-height: 20px;">
                        <img style="vertical-align: sub;height: 20px;width: 20px;" :src="(url=='/'||url=='/TenderProject'||searchType)?require('@/assets/top/classification11.png'):require('@/assets/top/classification1.png') ">
                        {{ $t('view.首页') }}
                    </div>
                </div>
                <div :class="['titleItem',url=='/MaterialProject'?'chose':'']" @click="Jump('/MaterialProject')">
                    <div :class="[url=='/Project'?'':'lineBorder']" style="height: 20px;">
                        <img style="vertical-align: sub;height: 20px;width: 20px;" :src="url=='/MaterialProject'?require('@/assets/top/classification21.png'):require('@/assets/top/classification2.png') ">
                        {{ $t('view.物资项目') }}
                    </div>
                </div>
                <div :class="['titleItem',url=='/Project'?'chose':'']" @click="Jump('/Project')">
                    <div :class="[url=='/ServiceItems'?'':'lineBorder']" style="height: 20px;">
                        <img style="vertical-align: sub;height: 20px;width: 20px;" :src="url=='/Project'?require('@/assets/top/classification31.png'):require('@/assets/top/classification3.png') ">
                        {{ $t('view.工程项目') }}
                    </div>
                </div>
                <div :class="['titleItem',url=='/ServiceItems'?'chose':'']" @click="Jump('/ServiceItems')">
                    <div style="height: 20px;">
                        <img style="vertical-align: sub;height: 20px;width: 20px;" :src="url=='/ServiceItems'?require('@/assets/top/classification41.png'):require('@/assets/top/classification4.png') ">
                        {{ $t('view.服务项目') }}
                    </div>
                </div>
            </div>
        </div>
        <Login ref="Login"></Login>

        <!-- 个人报名认证 -->
        <el-dialog :title="$t('view.个人认证')" :visible.sync="personalOpen" width="800px" append-to-body :close-on-click-modal="false">
            <el-form ref="authentication" :model="authentication" label-width="80px" :rules="rules">
                <div style="color: #B80008; margin-left: 160px;"> {{operationMsg}} </div>
                <el-form-item :label="$t('view.身份证(正面)')+':'" prop="corporateIdCardFront" label-width="160px">
                    <div style="display: flex; flex-wrap: flex-start">
                    <vuedraggable :list="authentication.corporateIdCardFront" :animation="200">
                        <div class="demo-upload-list" v-for="(item, __index) in authentication.corporateIdCardFront" :key="__index">
                        <template>
                            <img :src="item.filePath" class="upload-image"/>
                            <div class="demo-upload-list-cover">
                            <div>
                                <i class="el-icon-search"  size="30" @click="handleViewGoodsPicture(item.filePath)" ></i>
                                <i class="el-icon-delete-solid"  size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardFront,item)"></i>
                            </div>
                            </div>
                        </template>
                        </div>
                    </vuedraggable>
                    <el-upload action="#"  :limit="3"
                        v-if="authentication.corporateIdCardFront&&authentication.corporateIdCardFront.length == 0"
                        accept=".jpg, .jpeg, .png" list-type="picture-card" :show-file-list="false"
                        :file-list="authentication.corporateIdCardFront"
                        :http-request="corporateIdCardFrontUploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('view.身份证(反面)')+':'" prop="corporateIdCardOpposite" label-width="160px">
                    <div style="display: flex; flex-wrap: flex-start">
                    <vuedraggable :list="authentication.corporateIdCardOpposite" :animation="200">
                        <div class="demo-upload-list"  v-for="(item, __index) in authentication.corporateIdCardOpposite" :key="__index">
                        <template>
                            <img :src="item.filePath" class="upload-image"/>
                            <div class="demo-upload-list-cover">
                            <div>
                                <i class="el-icon-search" size="30" @click="handleViewGoodsPicture(item.filePath)"></i>
                                <i class="el-icon-delete-solid" size="30" @click="handleRemoveGoodsPicture(authentication.corporateIdCardOpposite,item)"></i>
                            </div>
                            </div>
                        </template>
                        </div>
                    </vuedraggable>
                    <el-upload action="#" :limit="3"
                        v-if="authentication.corporateIdCardOpposite&&authentication.corporateIdCardOpposite.length == 0"
                        accept=".jpg, .jpeg, .png" list-type="picture-card" :show-file-list="false"
                        :file-list="authentication.corporateIdCardOpposite"
                        :http-request="corporateIdCardOppositeUploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAuthentication">{{ $t('view.确 定') }}</el-button>
                <el-button @click="cancel">{{ $t('view.取 消') }}</el-button>
            </div>
        </el-dialog>
        <PowerOfAttorney ref="PowerOfAttorney"></PowerOfAttorney>
        <img v-if="$route.name=='Home'&&guidanceList.length" @click="show=true" style=" position: fixed;right: 40px;bottom: 40px;z-index: 2;width: 73px;height: 70px;margin-right: 15px;" src="../assets/top/robot.png" />
        <el-dialog :title="WelcomeObj.title" :visible.sync="dialogVisible" width="30%">
            <span v-html="WelcomeObj.operationDescription"></span>
        <div slot="footer" style="display: flex;justify-content: space-between;">
            <div style="font-size: 14px;color: #686C74;" @click="dialogVisible=false">直接跳过</div>
            <el-button round size="mini" type="primary" @click="next()">下一步</el-button>
        </div>
        </el-dialog>
        <el-dialog :title="startObj.title" :visible.sync="startVisible" width="30%">
            <span v-html="startObj.operationDescription"></span>
        <div slot="footer" style="display: flex;justify-content: space-between;">
            <el-button round size="mini" type="primary" @click="Previous()">上一步</el-button>
            <el-button round size="mini" type="primary" @click="use()">开始使用</el-button>
        </div>
        </el-dialog>
        <el-drawer :title="robotObj.title" :with-header="false" :visible.sync="show" direction="rtl" >
        <div style="display: flex;justify-content: space-between;padding: 21px 16px;border-bottom: 1px solid #E9EDF5;">
            <div>
                <span style="font-weight: bold;font-size: 18px;color: #000000;line-height: 23px;">使用指南</span>
                <span style="font-size: 13px;color: #A0A0A0;line-height: 16px;margin-left: 10px;">点击右侧【关闭】按钮即可关闭此抽屉</span>
            </div>
            <img style="width: 14px;height: 14px;cursor: pointer;" @click="show=false" src="../assets/top/close.png" />
        </div>
        <div style="display: flex;padding: 18px 16px;">
            <img style="width: 73px;height: 70px;margin-right: 15px;" src="../assets/top/robot.png" />
            <div style="background: #F9FAFC;border-radius: 10px;padding: 19px 14px;border: 1px solid #E9EDF5;" v-html="robotObj.operationDescription"></div>
        </div>
        </el-drawer>
    </div>
  </template>
  
  <script>
  import eventBus from '@/utils/eventBus.js' 
  import Login from './login.vue'
  import vuedraggable from "vuedraggable";
  import {uploadAndBpm} from "@/api/common/common";
  import PowerOfAttorney from '@/components/PowerOfAttorney.vue'
  import {authorizationVerify,getAuthorization,submitAuthorization,authorizationDownLoad,getToDetailQuoted} from '@/api/project'
  import {clientList,countMaterialPartPending} from '@/api/PersonalCenter'
  import {warningTime,getInfo, getRead} from '@/api/index'
  import XEUtils from "xe-utils";
  export default {
    components:{Login,vuedraggable,PowerOfAttorney},
    data() {
        return{
            ENV:'',//环境变量
            url:'',//记录当前属于哪个标签页
            input:'',
            languages:'',//当前语言
            chooseLanguage: window.localStorage.getItem('locale') || 'zh',
            language:[
                {"key":"zh","value":'简体中文'},
                {"key":"en","value":"English"},
                {"key":"lo","value":"bahasa Indonesia"},
            ],
            searchType:false,//搜索
            personalOpen:false,
            getAuthorization:{},
            operation:'',
            operationMsg:'',
            // 表单校验
            rules: {
                
                businessLicenseStart: [
                { required: true, message:this.$t('view.请选择营业执照有效期'), trigger: "blur" }
                ],
                businessLicenseEnd: [
                { required: true, message:this.$t('view.请选择营业执照有效期') , trigger: "blur" }
                ],
                isLegalRepresentative: [
                { required: true, message: this.$t('view.请选择是否法人'), trigger: "change" }
                ],
                corporateIdCardFront: [
                { required: true, message: this.$t('view.请上传身份证(正面)'), trigger: "change" }
                ],
                corporateIdCardOpposite: [
                { required: true, message: this.$t('view.请上传身份证(反面)'), trigger: "change" }
                ],
                authorizationFileList: [
                { required: true, message: this.$t('view.请上传投标授权委托书'), trigger: "change" }
                ],
                authorizationStart: [
                { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                ],
                authorizationEnd:[
                { required: true, message: this.$t('view.请选择授权委托书有效时间'), trigger: "change" }
                ],
            },
            authentication:{
                isLegalRepresentative:"",
                businessLicenseStart:null,
                businessLicenseEnd:null,
                corporateIdCardFront:[],
                corporateIdCardOpposite:[],
                authorizationStart:null,
                authorizationEnd:null
            }, // 企业认证
            HandlingMattersNum:0,
            guidanceList:[],
            WelcomeObj:{title:''},
            robotObj:{title:''},
            dialogVisible:false,
            startVisible:this.$store.state.user.startDialog,
            show:false,
            startObj:{},
        }
    },
    created(){
        // 初始化状态
        this.url=this.$route.path
        eventBus.$on('clear',(message)=>{  
            this.input=''
        })
        if(this.$store.getters.name){
            // 处理事项的数量
            this.clientList()
            this.warningTime()
          
        }
        eventBus.$on('HandlingMattersNum',(message)=>{  
            this.HandlingMattersNum=message
        })
        this.language.map(item=>{
            if(item.key==this.chooseLanguage)
            this.languages=item.value
        })
        this.ENV=process.env.VUE_APP_ENV
        this.getInfo()
    },  
     watch: {
        // 监听 vuex 里的 startDialog
        '$store.state.user.startDialog'(newVal) {
        // 一旦变化，自动同步到弹窗
        this.startVisible = newVal;
        }
    },
    methods: {
        use(){
            this.$store.dispatch('startDialogMd',false)
        },
        Previous(){
            this.use()
            let list =this.$store.state.user.guidanceList
            let index=list.length-1
            this.$store.dispatch('HandleGuidanceList', { list: list, current:index  })
            this.next()
        },
        next(){
            this.dialogVisible=false;
            let that=this
            setTimeout(function(){
                that.handleClick();
            },500)
        },
        getInfo(){ 
            getInfo({
                systemName:'ztbq',
                status:1,
                userId: this.$store.getters.userId,
            }).then(res=>{
                this.guidanceList=res.data.operationGuidesDetailList
                this.robotObj=this.guidanceList.find(item => item.guidePosition =='robot');
                if(!this.$store.getters.name)
                return
                if(res.data.isRead==1)
                return
                this.WelcomeObj= this.guidanceList.find(item => item.guidePosition =='Welcome');
                this.startObj=this.guidanceList.find(item => item.guidePosition =='start');
                // console.log('123',this.robotObj)
                this.dialogVisible=true
                getRead({id:res.data.id, userId: this.$store.getters.userId})
                // //Welcome 欢迎语 robot 机器人 需要过滤掉 开始使用 start
                const list = this.guidanceList.filter(item => !['Welcome','robot','start'].includes(item.guidePosition));
                this.$store.dispatch('HandleGuidanceList',{list:list,current:0})
            })
        },  
        warningTime(){
            warningTime().then(res=>{
                this.operationMsg=''
                if(res.data.error==0){
                    this.quotationSignup()
                }else if(res.data.error==2){
                   this.operationMsg= '授权委托书审批中'
                } else{
                    this.operationMsg=res.data.authorizationBook.status==3?'授权委托书被驳回' : res.data.day>0?'授权委托书将要过期！':'授权委托书过期！' 
                    this.$refs.PowerOfAttorney.show(res.data.authorizationBook.status==3?res.data.authorizationBook:{status:res.data.authorizationBook.status,authorizationFileList:[]}, res.data.day)
                }
            })
        },
        // 处理事项的数量
        async clientList(){
            let num =await getToDetailQuoted()
            let num1= await clientList({statusList:[0,4]})
            let num2 = await countMaterialPartPending()
            this.HandlingMattersNum=num.data+num1.total + num2.data*1
        },
        handleChangeLanguage(languageKey){
            // 用户修改了显示语言，重新设置语言
            this.chooseLanguage = languageKey;
            window.localStorage.setItem('locale', this.chooseLanguage);
            setTimeout(window.location.reload(), 1500);
        },
        beforeAvatarUpload(file){
            // image/png zip rar pdf
            if(!file.type.includes('pdf')){
                this.$message.error(this.$t('view.格式有误'));
                return false
            }
            return true
        },
        cancel() {
            this.personalOpen = false;
            this.reset();
        },
        downloadTemplate(){
            authorizationDownLoad().then(res=>{
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.$t('view.投标授权委托书模板.docx');
                link.click();
            })
        },
        corporateIdCardFrontUploadFile(data){
            this.uploadFile(data,this.authentication.corporateIdCardFront);
        },
        corporateIdCardOppositeUploadFile(data){
            this.uploadFile(data,this.authentication.corporateIdCardOpposite);
        },
        handleRemoveGoodsPicture(fileList,file) {
            XEUtils.remove(fileList, (item) => item.filePath === file.filePath); // el-upload 删除
        },
        handleViewGoodsPicture(url) {
            this.previewGoodsPicture = url;
            this.goodsPictureVisible = true;
        },
        uploadFile(data,fileList) {
            // 判断是否大于10M
            if (data.file.size / 1024 / 1024 > 1024) {
                this.$message({
                message: this.$t('view.上传文件不能超过20MB'),
                type: "warning"
                });
                this.uploadLoading = false;
                return;
            }
            if (data.file.size == 0) {
                this.$message({
                message: this.$t('view.上传文件不能为0KB'),
                type: "warning"
                });
                return;
            }
            let formData = new FormData();
            formData.append("file", data.file);
            formData.append("type", "qyrzsp");
            uploadAndBpm(formData).then(response => {
                if (response.code === 200) {
                    this.$message({ message:this.$t('view.上传成功'), type: "success" });
                    fileList.push(response.data);
                }
            }).catch(err => {
            });
        },
        // 提交
        submitAuthentication(){
            this.$refs["authentication"].validate(valid => {
                if (valid) {
                    submitAuthorization(this.authentication).then(response => {
                        this.$message.success(this.$t('view.提交成功'));
                        this.personalOpen = false;
                        this.reset();
                    });
                }
            });
        },
        // 表单重置
        reset() {
          
            this.resetForm("authentication");
        },
        quotationSignup(){
            // 校验当前用户是否需要企业认证
            authorizationVerify().then(res=>{
                if(res.code==200){
                    this.operation=res.data.operation
                    if ('Auth' == res.data.operation) {
                        // 企业认证
                        this.reset(); 
                        if("0" == res.data.operationUserType){
                            let that=this
                            this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                confirmButtonText:that.$t('view.确定'),
                                cancelButtonText: that.$t('view.取消'),
                                type: 'warning'
                            }).then(() => {
                                that.$router.push('EnterpriseCertification')
                            })
                        }else{
                            this.personalOpen = true;
                        } 
                        this.operationMsg = res.data.operationMsg;
                    }else if ('prompt' == res.data.operation){
                        // this.promptOpen = true;
                    }else if ('modify' == res.data.operation){
                        getAuthorization().then(res=>{
                            this.authentication = res.data;
                        });
                        // 企业认证
                        this.reset();
                        if("0" == res.data.operationUserType){
                            let that=this
                            this.$confirm(that.$t('view.是否进行企业认证'), that.$t('view.提示'), {
                                confirmButtonText:that.$t('view.确定'),
                                cancelButtonText: that.$t('view.取消'),
                                type: 'warning'
                            }).then(() => {
                                that.$router.push('EnterpriseCertification')
                            })
                        }else{
                            this.personalOpen = true;
                        }
                        this.operationMsg = res.data.operationMsg;
                    }else{
                        
                    }
                    
                }
            })
        },
        // 退出登录
        exit(){
            this.$store.dispatch("LogOut").then(res=>{
                this.$router.push('/')
            })
        },
        seach(){
            this.searchType=true
            this.url=''
            if(this.$route.name=='TenderProject'){
                eventBus.$emit('search',{input:this.input})
            }else{
                this.$router.push({
                    path: '/TenderProject',
                    query: {keyword: this.input || ''}
                })
            }

        },
        Jump(url){
            this.url=url
            if(this.$route.path==url)
            return
            this.searchType=false
            this.$router.push(url)
        }
    },
  };
  </script>
<style lang="scss">
.titleList  .el-input__inner{
    line-height: 36px;
    height: 36px;
}
.seachInput .el-input-group__append, .el-input-group__prepend{
    color: $mainBody-color;
    background: #F6E0E1
}
</style>
 <style lang="scss" scoped>
 .TopBox{
    background-image: url('../assets/top/bj.png');
    background-size: cover;
 }

 .top{
    width: 100%;
    height: 52px;
    line-height: 52px;
    font-size: 15px;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    span{font-size: 15px;}
 }
 .title{
    font-size: 24px;
    color: $mainBody-color;
    font-weight: 600;
    line-height: 33px; 
    margin-left: 5px;
    margin-right: 57px;
}
.dome1Bg{
    background: $mainBody-color;
}
 .search{
    background: $mainBody-color;
    color: #fff;
    width: 100px;
    border-radius: 0px;
    line-height: 36px;
    height: 36px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
 }
.classification{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 52px;
    .titleItem{
        height: 52px;
        display: flex;
        align-items: center;
        font-size: 18px;
    }

    div{
        flex:1;
        text-align: center;
        cursor: pointer;
    }

    .chose{
        position: relative;
        background: $mainBody-color;
        color: #fff;
    }
    .chose:after{
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        left: 50%;
        transform: translateX(-50%);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid $mainBody-color;
        margin-top:62px;
        // margin-left: 20px;
    }
}
.lineBorder{
    height: 20px;
    border-right: solid 1px $mainBody-color;
}

.demo-upload-list {
  width: 120px;
  height: 120px;
  text-align: center;
  border: 1px solid transparent;
  border-radius: 4px;
  display: inline-block;
  background: #fff;
  position: relative;
  margin-right: 4px;
  vertical-align: bottom;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: flex;
}

.demo-upload-list-cover div {
  margin-top: 38px;
  width: 100%;

  > i {
    width: 50%;
    margin-top: 8px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
}
.upload-image {
  width: 400px; /* 根据需要调整宽度 */
  height: auto; /* 保持宽高比 */
}
.btnClick{
    cursor: pointer;
    margin:0 10px;
    font-weight: bold;
}
.btnClick:hover{
    color: #B80008;
}
.HandlingMattersNum{
    position: absolute;
    top: -15px;
    right: -13px;
    background: #E02020;
    border-radius: 7px 7px 7px 2px;
    color: #FFFFFF;
    font-size: 13px;
    padding: 1px 4px;
    line-height: 20px;
}
 </style>

 
<style >
#driver-popover-item{
  max-width: 30vw !important;       /* 响应式最大宽度 */
  min-width: 280px;      /* 最小宽度 */
  padding: 20px;         /* 内边距 */
  border-radius: 8px;    /* 圆角 */
}
</style>